import React from "react";
import {
  DefaultTheme,
  DarkTheme,
  TeamsTheme,
  WordTheme,
} from "@fluentui/theme-samples";
import { ThemeProvider, CommandBarButton } from "@fluentui/react";


import { useLocalStorage } from "react-use";

// Design docs
// https://docs.microsoft.com/en-us/sharepoint/dev/design/semantic_slots
// https://github.com/microsoft/fluentui/wiki/Component-Styling

// // https://fabricweb.z5.web.core.windows.net/pr-deploy-site/refs/heads/master/theming-designer/
// const myTheme = createTheme({
//   palette: {
//     themePrimary: '#1177cc',
//     themeLighterAlt: '#0091ff',
//     themeLighter: '#007deb',
//     themeLight: '#aed2f0',
//     themeTertiary: '#65a9e0',
//     themeSecondary: '#2886d2',
//     themeDarkAlt: '#0f6cb8',
//     themeDark: '#0c5b9b',
//     themeDarker: '#094372',
//     neutralLighterAlt: '#2b2b2b',
//     neutralLighter: '#333333',
//     neutralLight: '#414141',
//     neutralQuaternaryAlt: '#4a4a4a',
//     neutralQuaternary: '#515151',
//     neutralTertiaryAlt: '#6f6f6f',
//     neutralTertiary: '#c8c8c8',
//     neutralSecondary: '#d0d0d0',
//     neutralPrimaryAlt: '#dadada',
//     neutralPrimary: '#ffffff',
//     neutralDark: '#f4f4f4',
//     black: '#f8f8f8',
//     white: '#212121',
//   }});


export const themes = {
  default: DefaultTheme,
  dark: DarkTheme,
  teams: TeamsTheme,
  word: WordTheme,
};

themes.default.semanticColors.bodyBackground = '#faf9f8';
themes.default.palette.white = '#FFFFFF';
themes.default.name = "default";


export const ThemeContext = React.createContext({
  theme: "dark",
  changeTheme: (name) => { },
});

export const useApplicationTheme = () => React.useContext(ThemeContext);

function ThemeConsumer({ children }) {
  const { theme } = useApplicationTheme();
  return <ThemeProvider theme={themes[theme]} applyTo={"body"}>{children}</ThemeProvider>;
}

export function DynamicThemeProvider({ children }) {
  const [theme, setTheme] = useLocalStorage("theme", "default");

  const changeTheme = (name) => themes[name] && setTheme(name);
  const themeContextValue = { theme, changeTheme };

  return (
    <ThemeContext.Provider value={themeContextValue}>
      <ThemeConsumer>{children}</ThemeConsumer>
    </ThemeContext.Provider>
  );
}

export function ThemeToggle({ as: ButtonComponent }) {
  const { theme, changeTheme } = useApplicationTheme();
  const menuItems = Object.keys(themes).map((key) => ({
    key,
    text: key,
    canCheck: true,
    checked: theme === key,
    onClick: () => changeTheme(key),
  }));

  return (
    <ButtonComponent
      menuProps={{ shouldFocusOnMount: true, items: menuItems }}
      iconProps={{ iconName: "Color" }}
    >
      {theme}
    </ButtonComponent>
  );
}

ThemeToggle.defaultProps = {
  as: CommandBarButton,
};
